const toQueryParam = (key, val) => `${encodeURIComponent(key)}=${encodeURIComponent(val)}`;
const makeQueryParam = (key, val) => {
    if (typeof val === 'object') {
        return (Object.keys(val)
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .map(objKey => `${encodeURIComponent(key)}.${objKey}=${encodeURIComponent(val[objKey])}`)
            .join('&'));
    }
    return toQueryParam(key, val);
};

export { makeQueryParam, toQueryParam };
//# sourceMappingURL=query.mjs.map
